import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from "react-router-dom";

import { Box, CircularProgress } from '@mui/material';

// Mirrors ProtectedRoutes — read the bootstrapped auth state from Redux,
// show a loading state while the /me check is in flight, then either bounce
// the already-signed-in user to /home or render the public outlet.
const PublicRoutes = () => {
    const authStatus = useSelector(state => state.auth.authStatus);

    if (authStatus === "unknown") {
        return (
            <Box
                className="flexCenterCenterRow"
                sx={{ height: "100vh", width: "100vw" }}>
                <CircularProgress />
            </Box>
        );
    }

    return authStatus === "authenticated" ? <Navigate to="/home" /> : <Outlet />;
};

export default PublicRoutes;
